import request from '@/utils/request'

// 分页查询费用信息
export function getPageList(params) {
  return request({
    url: '/hrApi/fee',
    method: 'get',
    params: params
  })
}

// 获取费用列表
export function getList(params) {
  return request({
    url: '/hrApi/fee/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑费用
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/fee',
    method: 'post',
    data: data
  })
}

// 删除费用
export function deleteData(id) {
  return request({
    url: '/hrApi/fee/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/fee.js